import BasePropertyView from 'BasePropertyView.js';
import { View } from 'backbone';
import contentTemplate from 'properties/style/background-clear-filter.ejs';

class StyleBackgroundClearFilterView extends View {

    initialize(opts) {
        //super.initialize(opts);
        this.options = opts || {};
        this.template = contentTemplate;
        this.tagName = 'div';
        this.id = opts.el;

        return this;
    }

    render() {
        //super.render();
        this.$el.empty();
        this.$el.html(this.template(this.model.toJSON()));

        return this;
    }

}

export default StyleBackgroundClearFilterView;
